"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _sso = _interopRequireDefault(require("./sso"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint no-shadow: ["error", { "allow": ["state"] }] */

/* eslint no-param-reassign: ["error", { "props": false }] */
// import User from '@/models/user'
const state = {
  apiToken: null,
  user: null
};
const getters = {
  apiToken(state) {
    return state.apiToken;
  },

  isEmbed() {
    const origins = window.location.ancestorOrigins;

    if (!origins || origins.length < 1) {
      return false;
    }

    const origin = origins[0];
    /**
      * @todo gestire ambiente di sviluppo
      */

    const isEmbed = origin === 'https://spaces.zwan.it';
    return isEmbed;
  },

  isLogged(state) {
    return !!state.user;
  },

  user(state) {
    return state.user;
  }

};
const actions = {
  fetchUserData({
    commit
  }, params = {}) {
    const sso = new _sso.default();
    return sso.user(params).then(({
      data
    }) => {
      commit('setUserData', data);
    });
  }

};
const mutations = {
  setUserData(state, userData) {
    state.user = userData.user; // new User(userData.user)

    state.apiToken = userData.token; // axios.defaults.headers.common.Authorization = `Bearer ${userData.token}`
  }

};
const spaces = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
var _default = spaces;
exports.default = _default;